import jwtDecode from "jwt-decode";
import { decode } from "hex-encode-decode";

export function clearSession() {
  ["auth", "login", "role", "password", "pass"].forEach((key) =>
    localStorage.removeItem(key)
  );
  sessionStorage.removeItem("registrationPassword");
}

export function getAccessToken() {
  localStorage.removeItem("password");
  localStorage.removeItem("pass");
  const stored = localStorage.getItem("auth");
  if (!stored) return null;
  try {
    const token = decode(stored);
    const { exp } = jwtDecode(token);
    if (Number.isFinite(exp) && exp * 1000 > Date.now()) return token;
  } catch {
    // A corrupt or expired saved session should return to login, not crash React.
  }
  clearSession();
  return null;
}
